export enum LiveStage {
    live = 'live',
    stage = 'stage'
}
